import * as React from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import {DisplayFeature} from "../domain";
import datacatalog, {NvdbFeatureType} from "../../../../integration/datacatalog/datacatalog-services";
import FeaturesState from "../domain/FeaturesState";
import * as selectors from "../selectors";
import {connect} from "react-redux";
import {clearPopup, ClearPopup, copyGeometry, CopyGeometry} from "../../../actions/actions";

interface StateProps {
    selectedFeatures: DisplayFeature[];
    selectedFeatureIds: Array<string>;
    supportedFeatureTypes: NvdbFeatureType[];
}

interface DispatchProps {
    doCopySelectedFeaturesWithType: CopyGeometry,
    doClosePopup: ClearPopup
}

type Props = StateProps  & DispatchProps;

interface State {
    copyTypeId?: number;
}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        selectedFeatures: selectors.selectedFeatures(state),
        selectedFeatureIds: selectors.selectedFeatureIds(state),
        supportedFeatureTypes: selectors.supportedGeometriesForSelectedFeatures(state)
    }
};

const mapDispatchToProps: DispatchProps = ({
    doCopySelectedFeaturesWithType: copyGeometry,
    doClosePopup: clearPopup
});

class SelectFeatureTypeModal extends React.Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            copyTypeId: undefined
        }
    }

    private doCopy() {
        this.props.doClosePopup();
        this.props.doCopySelectedFeaturesWithType(this.props.selectedFeatures, this.state.copyTypeId)   ;
    }

    render() {
        const {supportedFeatureTypes, doClosePopup, selectedFeatureIds} = this.props;
        const {copyTypeId} = this.state;
        const singular: boolean = selectedFeatureIds.length === 1;

        return (
            <Modal show={true} onHide={() => doClosePopup()}>
                <ModalHeader>
                    <ModalTitle>Kopier objekt til annen objekttype</ModalTitle>
                    <span>
                        {singular ? 'Et nytt vegobjekt ' : selectedFeatureIds.length + ' nye vegobjekter '}
                        vil bli opprettet.
                        {singular ? ' Det nye objektet ' : ' De nye objektene '}
                        vil få lik geometri og stedfesting som
                        {singular ? ' det originale objektet': ' de originale objektene'}
                        . Egenskapene følger ikke med. Velg vegobjekttype for
                        {singular ? ' det nye objektet' : ' de nye objektene'}.
                    </span>
                </ModalHeader>
                <form>
                    <ModalBody>
                        <ul>
                            {datacatalog &&
                                supportedFeatureTypes.map(type =>
                                    <li key={type.id}>
                                        <label>
                                            <input type="radio" name="featureType"
                                                   checked={copyTypeId === type.id}
                                                   value={type.id} onChange={(e) => this.setState({
                                                copyTypeId: parseInt(e.target.value)
                                            })}/>
                                            {` ${type.id}  ${type.name}`}
                                        </label>
                                    </li>)}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button bsStyle="primary"
                                disabled={!copyTypeId}
                                onClick={() => this.doCopy()}>OK</Button>
                        <Button bsStyle="warning" onClick={() => doClosePopup()}>Lukk</Button>
                    </ModalFooter>
                </form>
            </Modal>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectFeatureTypeModal);